var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field autocomplete" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.inputText,
          expression: "inputText"
        }
      ],
      attrs: {
        name: "sensis-input",
        placeholder: "Full address",
        type: "text",
        autocomplete: "nope",
        maxlength: "400"
      },
      domProps: { value: _vm.inputText },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputText = $event.target.value
          },
          _vm.checkAddress
        ],
        keydown: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.keyEnter($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.keyEnter($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "escape", undefined, $event.key, undefined)
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.keyEscape($event)
          }
        ],
        "!keydown": [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            return _vm.keyUp($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            return _vm.keyDown($event)
          }
        ],
        blur: function($event) {
          _vm.displaySuggestions = false
        },
        click: function($event) {
          return _vm.clickInside()
        }
      }
    }),
    _vm.fetchingDetails
      ? _c("div", { staticClass: "input-loading" }, [
          _c("img", {
            attrs: {
              alt: "Loading while fetching address' detail",
              src: require("@/assets/img/loading-tail-spin.svg")
            }
          })
        ])
      : _vm._e(),
    _vm.displaySuggestions
      ? _c("div", { staticClass: "suggestions" }, [
          _vm.isLoading
            ? _c("div", { staticClass: "suggestion-loading" }, [
                _c("img", {
                  attrs: {
                    alt: "Loading while fetching suggestions",
                    src: require("@/assets/img/loading-three-dots.svg")
                  }
                })
              ])
            : _vm._e(),
          !_vm.isLoading && _vm.suggestions.length > 0
            ? _c(
                "div",
                {
                  staticClass: "suggestion-list",
                  attrs: { id: "sensis-suggestion-list" }
                },
                _vm._l(_vm.suggestions, function(p) {
                  return _c(
                    "div",
                    {
                      key: p.index,
                      staticClass: "suggestion-item",
                      class: { "item-active": _vm.cursor === p.index },
                      attrs: { id: "sensis-suggestion-item-" + p.index },
                      on: {
                        mousedown: function($event) {
                          return _vm.selectAddress(p)
                        },
                        mouseover: function($event) {
                          _vm.cursor = p.index
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(p.formatted_address) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
          !_vm.isLoading && _vm.suggestions.length == 0
            ? _c("div", { staticClass: "suggestion-list" }, [
                _c(
                  "div",
                  {
                    staticClass: "suggestion-item empty",
                    on: { click: _vm.keyEscape }
                  },
                  [_vm._v("No Suggestions")]
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }